import { employeeStore, userStore } from '../../stores';
import { EmployeeController } from '../../controllers';
import React, { useEffect, useMemo, useState } from 'react';
import { Employees } from '../../pages/Employees';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { observer } from 'mobx-react';

const {
	getEmployees,
	getBusinessAdmins,
	getDepartments,
	getEmployeesGroups,
	getTags,
	getCommissions,
} = EmployeeController;

const EmployeesContainer = () => {
	const [addEmployees, setAddEmployees] = useState(false);
	const [specificEmployee, setSpecificEmployee] = useState(false);
	const [addBulkEmployees, setAddBulkEmployees] = useState(false);
	const [bulkEmployeesSalary, setBulkEmployeesSalary] = useState(false);
	const [uploadCommissionSheet, setUploadCommissionSheet] = useState(false);
	const [approveCommissionPayment, setApproveCommissionPayment] =
		useState(false);
	const [terminateEmployees, setTerminateEmployees] = useState(false);
	const [deptModal, setDeptModal] = useState(false);
	const [groupModal, setGroupModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loan, setLoanModal] = useState(false);

	const [limit, setLimit] = useState(400);
	const [filterQuery, setFilterQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');

	const employeesTableQuery = useMemo(() => {
		return `offset=${currentPage + 1}&limit=${limit}`;
	}, [currentPage, limit]);

	const { isLoading, data, isFetching } = EmployeeController.useGetEmployees(
		employeesTableQuery,
		filterQuery,
		searchQuery
	);

	const onLimitChange = limit => {
		setLimit(limit);
		setCurrentPage(0);
	};

	const navigate = useNavigate();
	useEffect(() => {
		const setEmployees = async () => {
			setLoading(true);
			await Promise.all([
				getEmployeesGroups(),
				getEmployees(),
				getDepartments(),
				getBusinessAdmins(),
				getTags(),
				getCommissions(),
			]);
			setLoading(false);
		};
		setEmployees();
	}, [employeeStore]);

	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			getEmployeesGroups(),
			getEmployees(),
			getDepartments(),
			getBusinessAdmins(),
		]);
		setLoading(false);
	};

	const isOnboardingDone = () => {
		if (userStore.isOnBoardingDone === 'false') {
			MimaToastUtil.error({
				message: constant.OnboardingRequired,
			});
			localStorage.setItem(constant.RoutePath, constant.Routes.Employees);
			return navigate(constant.Routes.OnboardingStageOne);
		}
	};

	const goToAddEmployees = () => {
		// isOnboardingDone();
		setAddEmployees(true);
	};

	const goToSpecificEmployee = employee => {
		employeeStore.setSelectedEmployee(employee);
		setSpecificEmployee(true);
	};

	const goToDept = () => {
		setDeptModal(true);
	};
	const goToLoan = () => {
		// isOnboardingDone();
		setLoanModal(true);
	};

	const goToGroup = () => {
		setGroupModal(true);
	};

	const goToBulkEmployeesSalary = () => {
		setBulkEmployeesSalary(true);
	};
	const goToUploadCommissionSheet = () => {
		setUploadCommissionSheet(true);
	};

	const goToApproveCommissionPayment = () => {
		setApproveCommissionPayment(true);
	};

	const goToBulkAdd = () => {
		setAddBulkEmployees(true);
	};

	const goToBulkTerminate = () => {
		setTerminateEmployees(true);
	};

	const onSubmit = async payload => {
		let query = '';
		setLoading(true);
		let count = 0;
		if (payload && Object.keys(payload).length > 0) {
			for (const [key, value] of Object.entries(payload)) {
				if (value !== '') {
					query += count === 0 ? `${key}=${value}` : `&${key}=${value}`;
					count++;
				}
			}
		}
		await EmployeeController.getEmployees(query);
		setLoading(false);
	};
	const resetFilter = () => {
		onSubmit();
	};

	const closeModal = () => {
		setAddEmployees(false);
		setSpecificEmployee(false);
		setDeptModal(false);
		setLoanModal(false);
		setAddBulkEmployees(false);
		setTerminateEmployees(false);
		setBulkEmployeesSalary(false);
		setUploadCommissionSheet(false);
		setApproveCommissionPayment(false);
		setGroupModal(false);
		setLoanModal(false);
		employeeStore.setTrackCreateEmployee({});
		employeeStore.setSelectedEmployee({});
	};

	const employeeNav = [
		{
			title: `Add Employees`,
			clickAction: goToAddEmployees,
		},
		{
			title: 'Add Bulk Employees',
			clickAction: goToBulkAdd,
		},
		{
			title: 'Terminate Bulk Employees',
			clickAction: goToBulkTerminate,
		},
		{
			title: 'Departments',
			clickAction: goToDept,
		},
		{
			title: 'Loan',
			clickAction: goToLoan,
		},
		{
			title: 'Bulk Salary Update',
			clickAction: goToBulkEmployeesSalary,
		},
		{
			title: 'Upload Commission Sheet',
			clickAction: goToUploadCommissionSheet,
		},
		{
			title: 'Action Commission Payments',
			clickAction: goToApproveCommissionPayment,
		},
		{
			title: 'Download Report',
		},
	];

	return (
		<div>
			<Employees
				addEmployees={addEmployees}
				loading={loading}
				commissionList={employeeStore.commissions}
				refresh={refresh}
				employeesList={employeeStore.employees}
				onSubmit={onSubmit}
				resetFilter={resetFilter}
				closeModal={closeModal}
				employeeNav={employeeNav}
				loan={loan}
				bulkEmployeesSalary={bulkEmployeesSalary}
				uploadCommissionSheet={uploadCommissionSheet}
				approveCommissionPayment={approveCommissionPayment}
				specificEmployee={specificEmployee}
				goToSpecificEmployee={goToSpecificEmployee}
				deptModal={deptModal}
				addBulkEmployees={addBulkEmployees}
				terminateEmployees={terminateEmployees}
				groupModal={groupModal}
				isLoading={isLoading}
				employeesdata={data}
				isFetching={isFetching}
				limit={limit}
				onLimitChange={onLimitChange}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
			/>
		</div>
	);
};

export default observer(EmployeesContainer);
